"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICONS = exports.COINS = exports.FONT_FAMILY = exports.FONT_WEIGHT = exports.NEUE_FONT_SIZE = exports.FONT_SIZE = exports.Z_INDEX = exports.LAYOUT_SIZE = exports.SCREEN_SIZE = void 0;
exports.SCREEN_SIZE = {
    UNAVAILABLE: '260px',
    SM: '576px',
    MD: '768px',
    LG: '992px',
    XL: '1200px',
};
exports.LAYOUT_SIZE = {
    MENU_SECONDARY_WIDTH: '300px',
    GUIDE_PANEL_WIDTH: '350px',
};
exports.Z_INDEX = {
    MODAL: 10000,
    NAVIGATION_BAR: 30,
    GUIDE_PANEL: 15,
    BETA_BADGE: 13,
    GUIDE_BUTTON: 10,
};
exports.FONT_SIZE = {
    BIG: '18px',
    NORMAL: '16px',
    SMALL: '14px',
    TINY: '12px',
    BUTTON: '14px',
    H1: '36px',
    H2: '24px',
};
exports.NEUE_FONT_SIZE = {
    NANO: '10px',
    TINY: '12px',
    SMALL: '14px',
    NORMAL: '16px',
    H1: '24px',
    H2: '20px',
};
exports.FONT_WEIGHT = {
    LIGHT: 300,
    REGULAR: 400,
    MEDIUM: 500,
    DEMI_BOLD: 600,
    BOLD: 700,
};
exports.FONT_FAMILY = {
    TTHOVES: 'TT Hoves',
};
exports.COINS = [
    'ada',
    'bch',
    'btc',
    'test',
    'btg',
    'dash',
    'dgb',
    'doge',
    'etc',
    'owc',
    'owdt',
    'eth',
    'ltc',
    'nmc',
    'trop',
    'txrp',
    'vtc',
    'xrp',
    'zec',
];
exports.ICONS = [
    'APP',
    'ARROW_DOWN',
    'ARROW_UP',
    'ARROW_LEFT',
    'ARROW_LEFT_LONG',
    'ARROW_RIGHT',
    'ARROW_RIGHT_LONG',
    'ARTICLE',
    'ATTACHMENT',
    'BROADCAST',
    'CHECK',
    'CHECK_ACTIVE',
    'COIN',
    'COINS',
    'COPY',
    'CROSS',
    'DASHBOARD',
    'DEVICE',
    'EXCHANGE',
    'INFO',
    'INFO_ACTIVE',
    'LOG',
    'LIGHTBULB',
    'MENU',
    'MORE',
    'NON_SUITE',
    'PASSWORDS',
    'PLUS',
    'QR',
    'QUESTION',
    'QUESTION_ACTIVE',
    'RECEIVE',
    'REFRESH',
    'SEARCH',
    'SEND',
    'SETTINGS',
    'SIGN',
    'SIGNATURE',
    'SORT',
    'SUPPORT',
    'TIPS',
    'TRANSACTIONS',
    'TREZOR',
    'WALLET',
    'WALLET_HIDDEN',
    'EXTERNAL_LINK',
    'T1',
    'T2',
    'BACK',
    'SHOW',
    'HIDE',
    'DOWNLOAD',
    'EDIT',
    'WARNING',
    'WARNING_ACTIVE',
    'LABEL',
    'LABEL_ACTIVE',
    'TODO',
    'DISCREET',
    'PIN',
    'BACKUP',
    'COLLAPSE',
    'NOTIFICATION',
    'SHOP',
    'UP',
    'DOWN',
    'CANCEL',
    'GRID',
    'TABLE',
    'ASTERISK',
    'EJECT',
    'RBF',
    'TRANSFER',
    'LOCK',
    'LOCK_ACTIVE',
    'CLOCK',
    'CALENDAR',
    'PDF',
    'CSV',
    'BINARY',
    'IMAGE',
    'MEDIUM',
    'TAG',
    'GAS',
    'DATA',
    'BANK',
    'BUY',
    'CREDIT_CARD',
    'TREZOR_LOGO',
    'FEEDBACK',
    'OS_LINUX',
    'OS_LINUX_ARM64',
    'OS_MAC',
    'OS_WINDOWS',
    'TRADE',
    'WINDOW_CLOSE',
    'WINDOW_MINIMIZE',
    'WINDOW_MAXIMIZE',
    'WINDOW_MAXIMIZE_MAC',
    'WINDOW_RESTORE',
    'WINDOW_RESTORE_MAC',
    'TOR',
    'RECOVER',
    'NEW',
    'SEED_SINGLE',
    'SEED_SHAMIR',
    'HOLOGRAM',
    'PACKAGE',
    'VERIFIED',
    'ANCHOR',
    'PENCIL',
    'PENCIL_LINE',
    'KEY',
];
